import { Vue, Component } from 'vue-property-decorator'
import LeftTree from './components/Tree.vue'
import './index.less'
import Location from './components/Location'
import Material from './components/Material'

@Component({
  components: {
    LeftTree
  }
})
export default class ReservoirLocation extends Vue {
  areaId = '' // 库区id
  locationId = '' // 库位id
  rowBind = '0'

  handleSelect(selects) {
    if (selects || selects === '0') {
      this.areaId = selects
      this.locationId = ''
    }
  }

  changeLocation(value,rowBind) {
    this.locationId = value
    console.log(665588,rowBind)
    this.rowBind = rowBind
  }

  render() {
    return (
      <div class="business-location">
        <div class="tree-panel">
          <left-tree select={this.handleSelect}> </left-tree>
        </div>
        <div class="table-panel">
          <div class="panel1">
            <Location areaId={this.areaId} changeLocation={this.changeLocation}/>
          </div>
          <div class="panel2">
            <Material areaId={this.areaId} locationId={this.locationId} isBind={this.rowBind}/>
          </div>
        </div>
      </div>
    )
  }
}
